import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { useFrontendTable } from "components/table";
import { CustomDialog } from "components/dialogs/Dialogs";
import { truncate } from "utils";
import { GetLocationAvailabilityQuery } from "__generated__/view/availability/graphql/quayAvailability.queries.generated";

type LocationAvailability = NonNullable<GetLocationAvailabilityQuery["locationAvailability"]>;
type Crane = NonNullable<LocationAvailability["crane"]>;
type HandlingRate = NonNullable<Crane["handlingRates"]>[number];

interface CraneSpeedDialogProps {
    open: boolean;
    onClose: () => void;
    handlingRates: HandlingRate[];
}

const CraneSpeedDialog = ({
	open,
	onClose,
	handlingRates,
}: CraneSpeedDialogProps) => {

	const { tableProps } = useFrontendTable({
		id: "quayCraneSpeed",
		content: handlingRates.map(it => ({ ...it, id: it.id ?? 0 })),
		saveForOrganizationEnabled: false,
	});

	return (
		<CustomDialog
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "MOORING_AVAILABILITIES_CRANE_SPEED" })}>
			<Table
				{...tableProps}
				columns={[ {
					id: "product.name",
					title: intl.formatMessage({ id: "LOCATION" }),
					width: 350,
					render: (row: HandlingRate) =>
						<span>{row.product?.name} ({truncate(row.product?.code || intl.formatMessage({ id: "UNKNOWN" }), 15)})</span>,
				}, {
					id: "handlingRateInTonsPerHour",
					title: `${intl.formatMessage({ id: "CRANE_SPEED" })} (${intl.formatMessage({ id: "UNIT_TON_PER_HOUR" })})`,
				} ]}
			/>
		</CustomDialog>
	);
};
export default CraneSpeedDialog;
